import * as React from 'react';

import { Steps } from 'antd';
import { ButtonType, HtmlType, Space } from 'farmhub-ui-core';

import { CButton } from 'components';
import { GlobalStyle } from 'styled';

import { Wrapper, TextStep, ContentStep } from './styles';

const { Step } = Steps;

interface StoreCreatePageContentProps {
  handleSubmitStep: (e: number) => void;
  handleNextStep: () => any;
  ListStep: any[];
  isSubmitting: boolean;
  currentTab: number;
  handleChangeCurrentStep: (e: number) => void;
}

const StoreCreatePageDesktopContent = ({
  handleSubmitStep,
  handleNextStep,
  ListStep,
  isSubmitting,
  currentTab,
  handleChangeCurrentStep,
}: StoreCreatePageContentProps): JSX.Element => (
  <Wrapper>
    <Steps
      current={currentTab}
      labelPlacement="vertical"
      style={{ width: 500 }}
    >
      <Step
        style={{ cursor: 'pointer' }}
        title="Thông tin"
        onClick={() => handleChangeCurrentStep(0)}
      />
      <Step
        style={{ cursor: 'pointer' }}
        title="Danh mục"
        onClick={() => handleChangeCurrentStep(1)}
      />
      <Step
        style={{ cursor: 'pointer' }}
        title="Chứng nhận"
        onClick={() => handleSubmitStep(2)}
      />
    </Steps>
    <Space height={24} />
    <ContentStep>
      {ListStep[currentTab]}
      <Space height={12} />
      <CButton
        htmlType={HtmlType.Submit}
        loading={isSubmitting}
        type={ButtonType.Primary}
        width="420px"
        onClick={handleNextStep}
      >
        Xác nhận
      </CButton>
      <div id="recaptcha-container" />
    </ContentStep>
    <GlobalStyle />
  </Wrapper>
);

export default StoreCreatePageDesktopContent;
